/* eslint-disable react/prop-types */
import React from 'react';
import { useGetXstyledProps } from '../../xstyledProps';

export const TestComponent = (props) => {
  const xstyledProps = useGetXstyledProps(props);

  props.signal(xstyledProps);

  return (
    <div {...xstyledProps} data-testid="xstyled-div">
      Some random div
    </div>
  );
};
